import { render, staticRenderFns } from "./footerBuild.vue?vue&type=template&id=7324287e"
import script from "./footerBuild.vue?vue&type=script&lang=js"
export * from "./footerBuild.vue?vue&type=script&lang=js"
import style0 from "./footerBuild.vue?vue&type=style&index=0&id=7324287e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports